import { AxiosResponse } from "axios";
import { AltiusRes, IPaginationResponse } from "store/types";
import {
  IProfileData,
  IProfileMetadata,
  IRecommendationDataMessage,
  IUpdateProfileData
} from "store/types/user/social";

import { AsyncActions, AsyncActionsParams } from "../base";

export interface ISocialActions {
  createRecommendationMessageAction: (data: IRecommendationDataMessage) => Promise<void>;
  getProfileMetadata: () => Promise<IProfileMetadata>;
  getProfileData: (id: number) => Promise<IProfileData>;
  updateProfileDataAction: (data: IUpdateProfileData) => Promise<void>;
  getPaginationProfiles: (page: number, per_page: number) => Promise<IPaginationResponse<IProfileData>>;
  getProfileCompletionAction: () => Promise<number>;
  hideCompletionPopupAction: () => Promise<void>;
}

export class SocialActions extends AsyncActions implements ISocialActions {
  public constructor(params: AsyncActionsParams) {
    super(params);
  }

  public createRecommendationMessageAction = async (data: IRecommendationDataMessage): Promise<void> => {
    try {
      await this.api.post({
        url: "api/v0.0.3/profile/request",
        data
      });
    } catch (error) {
      throw error;
    }
  };

  public getProfileMetadata = async (): Promise<IProfileMetadata> => {
    try {
      const {
        data: { data: payload }
      }: AxiosResponse<{ data: IProfileMetadata }> = await this.api.get({
        url: "api/v0.0.3/profile/metadata"
      });
      return payload;
    } catch (error) {
      throw error;
    }
  };

  public getProfileData = async (id: number): Promise<IProfileData> => {
    try {
      const {
        data: { data: payload }
      }: AxiosResponse<{ data: IProfileData }> = await this.api.get({
        url: `api/v0.0.3/profile/${id}`
      });
      return payload;
    } catch (error) {
      throw error;
    }
  };

  public updateProfileDataAction = async (data: IUpdateProfileData): Promise<void> => {
    const { userId } = data;
    try {
      await this.api.post({
        url: `api/v0.0.3/profile/${userId}`,
        data: { ...data }
      });
    } catch (error) {
      throw error;
    }
  };

  public getPaginationProfiles = async (page: number, per_page: number): Promise<IPaginationResponse<IProfileData>> => {
    try {
      const {
        data: { data: payload }
      }: AxiosResponse<{ data: IPaginationResponse<IProfileData> }> = await this.api.get({
        url: "api/v0.0.3/profile",
        params: {
          page,
          per_page
        }
      });
      return payload;
    } catch (error) {
      throw error;
    }
  };

  public getProfileCompletionAction: ISocialActions["getProfileCompletionAction"] = async () => {
    const {
      data: {
        data: { profile_completion }
      }
    } = await this.api.get<AltiusRes<{ profile_completion: number }>>({ url: "/api/v0.0.3/profile/completion" });
    return profile_completion;
  };

  public hideCompletionPopupAction: ISocialActions["hideCompletionPopupAction"] = async () => {
    await this.api.post({ url: "api/v0.0.3/profile/hide-completion-popup" });
  };

}
